"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const react_use_1 = require("react-use");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const KeyboardArrowUp_1 = __importDefault(require("@mui/icons-material/KeyboardArrowUp"));
const KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const ArrowDropDownRounded_1 = __importDefault(require("@mui/icons-material/ArrowDropDownRounded"));
const QSelect_1 = __importDefault(require("components/QSelect"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const AMGraph_1 = __importDefault(require("./AMGraph"));
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const customSelectInputProps = {
    style: {
        display: 'inline-flex',
        borderRadius: 16,
        fontSize: 14,
        fontWeight: 400,
        height: 16,
        marginLeft: 20,
        paddingLeft: 16,
        paddingRight: 32,
    },
};
const ProjectedBalances = ({ accountIds, showGraph }) => {
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const [dateRange, setDateRange] = (0, react_1.useState)(datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.dateRangeProjectedBalances);
    const [openBoth, setOpenBoth] = (0, react_1.useState)(showGraph ? datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.projectedOpen : true);
    const [, setSelectedId] = (0, react_1.useState)(null);
    const timeout = (0, react_1.useRef)(null);
    const { classes } = useStyle();
    (0, react_use_1.useUnmount)(() => {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
    });
    const toggleOpen = () => {
        setOpenBoth(!openBoth);
        timeout.current = setTimeout(() => setDatasetPreference({ projectedOpen: !openBoth }), 50);
    };
    const updateSelectedType = (e) => {
        setDateRange(e.target.value);
        timeout.current = setTimeout(() => setDatasetPreference({ dateRangeProjectedBalances: e.target.value }), 600);
    };
    const selectProps = {
        className: classes.customSelect,
        IconComponent: ArrowDropDownRounded_1.default,
        SelectDisplayProps: customSelectInputProps,
        classes: {
            icon: classes.customDropArrow,
            root: classes.chipRoot,
        },
    };
    return (<div>
      <div className={classes.selectLine}>
        {!showGraph && <Typography_1.default variant="h6" noWrap>{'Upcoming'}</Typography_1.default>}
        <div className={showGraph ? classes.leftMenu : classes.displayNone}>
          <Typography_1.default variant="h6" noWrap>
            Projected
          </Typography_1.default>
          {(openBoth) &&
            <QSelect_1.default id="dropdown-date-range" value={dateRange} onChange={updateSelectedType} {...selectProps}>
            <MenuItem_1.default value="fourteen" id="projected-balance-next-14-days">Next 2 weeks</MenuItem_1.default>
            <MenuItem_1.default value="thirty" id="projected-balance-next-30-days">Next 1 month</MenuItem_1.default>
            <MenuItem_1.default value="sixty" id="projected-balance-next-60-days">Next 2 months</MenuItem_1.default>
            <MenuItem_1.default value="ninety" id="projected-balance-next-90-days">Next 3 months</MenuItem_1.default>
            <MenuItem_1.default value="oneEighty" id="projected-balance-next-180-days">Next 6 months</MenuItem_1.default>
          </QSelect_1.default>}
        </div>
        <div className={classes.rightMenu}>
          <IconButton_1.default id={'display_carousel_button'} onClick={toggleOpen} className={classes.toggleButton}>
            {openBoth ? <KeyboardArrowUp_1.default className={classes.toggleIcon}/> : <KeyboardArrowDown_1.default className={classes.toggleIcon}/>}
          </IconButton_1.default>
        </div>
      </div>
      {showGraph && openBoth &&
            <AMGraph_1.default accountIds={accountIds} dateRange={dateRange} oneColor transactionsPageOptimize setSelectedId={(id) => {
                    setSelectedId(id);
                }}/>}
    </div>);
};
exports.default = ProjectedBalances;
